import React, {useState} from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import {getLabelShortName, uuidShortName} from '../../helpers';
import PropTypes from 'prop-types';
import {Tooltip} from '@material-ui/core';

function CamerasFilter(props) {
  const listItemStyle = {paddingLeft: 4};
  const listItemClass = {root: 'grouplist'};

  const [dOpen, setDOpen] = useState(false);
  const {filterSelectedType = '', filterselectedItem = '', onAllSelected, onDeviceSelected} = props;

  function getFilterNames(item) {
    let {route, label} = item;
    let isNotEmptyLabel = label !== undefined && label !== null && label !== '';
    let tooltip = isNotEmptyLabel ? `${route} - ${label}` : route;
    let listItemName = isNotEmptyLabel ? `${uuidShortName(route)} - ${getLabelShortName(label)}` : uuidShortName(route);
    return {tooltip, listItemName};
  }

  function byDeviceList() {
    return (
      <Collapse in={dOpen} timeout="auto">
        <List disablePadding>
          {
            props && props.devices ?
              props.devices.map(item => {
                const {tooltip, listItemName} = getFilterNames(item);
                return (
                  <ListItem
                    button
                    key={item.label}
                    selected={filterSelectedType === 'By Device' && filterselectedItem === item.route}
                    onClick={() => onDeviceSelected(item.route)}
                  >
                    <Tooltip title={tooltip}>
                      <ListItemText>{listItemName}</ListItemText>
                    </Tooltip>
                  </ListItem>
                )
              }) : ''
          }
        </List>
      </Collapse>
    );
  }

  return (
    <div>
      <div className="muted margin-bottom-small">Filter</div>
      <List>
        <ListItem disableGutters style={listItemStyle} classes={listItemClass} button key="All" selected={filterSelectedType === 'All'} onClick={() => onAllSelected('All')}>
          <ListItemText primary="All"/>
        </ListItem>
        <ListItem disableGutters style={listItemStyle} classes={listItemClass} button key="By Device" onClick={() => setDOpen(open => !open)}
        >
          <ListItemText primary="By Device"/>
          {dOpen ? <ExpandLess/> : <ExpandMore/>}
        </ListItem>
        {byDeviceList()}
      </List>
    </div>
  );
}

CamerasFilter.propTypes = {
  filterSelectedType: PropTypes.string.isRequired,
  filterselectedItem: PropTypes.string.isRequired,
  regionList: PropTypes.array.isRequired,
  devices: PropTypes.array.isRequired,
  onAllSelected: PropTypes.func.isRequired,
  onRegionSelected: PropTypes.func.isRequired,
  onDeviceSelected: PropTypes.func.isRequired
};

export default React.memo(CamerasFilter);
